import React, { Fragment, useState } from 'react';
import { FindCourse, Filter } from '../../../Constant';
import { Col, Card, CardHeader, CardBody, Input } from 'reactstrap';
import { Collapse } from 'reactstrap';
import { ChevronDown, ChevronUp, Search } from 'react-feather';
import { H5, Btn } from '../../../AbstractElements';
import CatCheckBox from './CheckBox/CatCheckBox';
import DurationCheckBox from './CheckBox/DurationCheck';
import PriceCheck from './CheckBox/PriceCheck';
import StatusCheck from './CheckBox/StatucCheck';

const FindCourseClass = () => {
  const [isFilter, setIsFilter] = useState(true);
  return (
    <Fragment>
      <Col xl='12'>
        <Card>
          <CardHeader>
            <H5 className='mb-0 p-0'>
              <Btn className='btn btn-link accordion-icon' onClick={() => setIsFilter(!isFilter)} color='transperant'>
                {FindCourse}
                {isFilter ? <ChevronUp /> : <ChevronDown />}
              </Btn>
            </H5>
          </CardHeader>
          <Collapse isOpen={isFilter}>
            <div className='collapse show'>
              <CardBody className='filter-cards-view animate-chk'>
                <div className='job-filter'>
                  <div className='faq-form'>
                    <Input className='form-control' type='text' placeholder='Search..' />
                    <Search className='search-icon' />
                  </div>
                </div>
                <CatCheckBox />
                <DurationCheckBox />
                <PriceCheck />
                <StatusCheck />
                <Btn color='primary text-center'>{Filter}</Btn>
              </CardBody>
            </div>
          </Collapse>
        </Card>
      </Col>
    </Fragment>
  );
};

export default FindCourseClass;
